// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SpinnerDot_spinner__3vFz7","spin":"SpinnerDot_spin__c-Dla"};